// utils/socketManager.js
import { io } from "socket.io-client";

let socket = null;
let bidListeners = []; // Store callbacks for 'newBid' event

export const initializeSocket = () => {
  console.log("🔌 Initializing socket...");

  if (!socket) {
    socket = io(`https://${window.location.hostname}/`, {   
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Socket connection error:", error.message);
    });

    // Central handler for 'newBid'
    socket.on("newBid", (data) => {
      console.log("📡 Received newBid:", data);
      bidListeners.forEach((cb) => {
        if (typeof cb === "function") cb(data);
      });
    });
  }
};

// Register a listener for newBid
export const onNewBid = (callback) => {
  if (typeof callback === "function") {
    // Avoid duplicate registrations
    if (!bidListeners.includes(callback)) {
      bidListeners.push(callback);
    }
  }
};

// Emit event
export const emitDataReceived = (payload = {}) => {
  if (socket && socket.connected) {
    socket.emit("bidUpdate", payload);
    console.log("📤 Emitted bidUpdate with:", payload);
  } else {
    console.warn("⚠️ Socket is not connected. Cannot emit data.");
  }
};

// Disconnect socket
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    bidListeners = []; // Clear all listeners
    console.log("🔌 Socket disconnected");
  }
};
